import { useHotelApplicationDataQuery } from "@/components/features/_shared/repository/hotel-application-data/query";

import { useDeletePlan } from "../../repository/mutation/delete-plan";
import { useFetchPlanList } from "../../repository/query/fetch-plan-list";

type Props = {
	hotelID: string;
};

export const usePlanList = ({ hotelID }: Props) => {
	const { plans, secrets, showScConnectedColumn } = useFetchPlanList({ hotelID });
	const { onDeletePlan } = useDeletePlan({ hotelID });

	const { hotelApplicationData } = useHotelApplicationDataQuery(hotelID);

	return {
		plans,
		secrets,
		onDeletePlan,
		inUseBasic: hotelApplicationData?.hotelApplicationStatus.inUseBasic || false,
		showScConnectedColumn,
	};
};
